<div class="export-products" nz-form nzLayout="vertical">
  <div class="export-products__title">
    {{ 'modal.export.exportOptions.title' | crmTranslate }}
  </div>
  <nz-radio-group [(ngModel)]="exportType">
    <label class="radio-option" nz-radio [nzValue]="ExportType.table">
      {{ 'modal.export.exportOptions.table' | crmTranslate }}
    </label>
    <label class="radio-option" nz-radio [nzValue]="ExportType.media">
      {{ 'modal.export.exportOptions.media' | crmTranslate }}
    </label>
  </nz-radio-group>

  <div
    *ngIf="exportType === ExportType.media"
    class="export-product__media-export"
  >
    <nz-divider></nz-divider>
    <nz-form-item>
      <nz-form-label class="export-products__title">
        {{ 'modal.export.mediaOptions.title' | crmTranslate }}
      </nz-form-label>
      <nz-form-control
        [nzValidateStatus]="hasError() ? 'error' : 'success'"
        [nzErrorTip]="'modal.export.error.required' | crmTranslate"
      >
        <div>
          <label
            *ngFor="let mediaType of exportMediaTypes"
            class="radio-option"
            nz-checkbox
            [(ngModel)]="exportOptions[mediaType.value]"
          >
            {{ mediaType.label | crmTranslate }}
          </label>
        </div>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div class="export-products__actions">
    <app-button
      [id]="'product-export-download'"
      [iconType]="'download'"
      [title]="'Download'"
      [loading]="exportProcessing"
      (click)="onDownload()"
    ></app-button>
  </div>
</div>
